import { carrierHashMap } from '~/constants/carriers';
import { WeightUnit } from '~/constants/weight';
import { SavedAPIAddress } from '~/types/APIAddress';
import { normalizeCarrierName } from '~/types/Carrier';
import CarrierBuildingLocation from '~/types/CarrierBuildingLocation';
import { ActionKeys } from './constants';

// TODO: Add types to function params
export function changePickupLocation(name: string, value: string) {
  return <const>{
    type: ActionKeys.PICKUPS_CHANGE_LOCATION,
    payload: {
      name,
      value,
    },
  };
}

// TODO: Add types to function params
export function getTransactionsForCarrier(
  carrier: string,
  startDate: string,
  endDate: string,
  preferredMassUnit: WeightUnit,
) {
  return <const>{
    type: ActionKeys.PICKUPS_FETCH_TRANSACTIONS,
    payload: {
      carrier,
      startDate,
      endDate,
      preferredMassUnit,
    },
  };
}

// TODO: Add types to function params
export function getTransactionsForCarrierSuccess(payload: {
  totalWeight: number;
  totalTransactions: number;
  transactionObjectIds: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  serviceLevelInfo: any;
}) {
  return <const>{
    payload,
    type: ActionKeys.PICKUPS_FETCH_TRANSACTIONS_SUCCESS,
  };
}

// TODO: Add types to function params
export function getTransactionsForCarrierError(errorMessage) {
  return <const>{
    type: ActionKeys.PICKUPS_FETCH_TRANSACTIONS_ERROR,
    payload: {
      errorMessage,
    },
  };
}

// TODO: Add types to function params
export function getCarrierAccountId(carrier: string) {
  const carrierObj = carrierHashMap[normalizeCarrierName(carrier)];
  return <const>{
    type: ActionKeys.PICKUPS_FETCH_CARRIER_ACCOUNT_ID,
    payload: {
      carrier: carrierObj.id,
    },
  };
}

// TODO: Add types to function params
export function getCarrierAccountIdSuccess(payload) {
  return <const>{
    payload,
    type: ActionKeys.PICKUPS_FETCH_CARRIER_ACCOUNT_ID_SUCCESS,
  };
}

// TODO: Add types to function params
export function getCarrierAccountIdError(errorMessage) {
  return <const>{
    type: ActionKeys.PICKUPS_FETCH_CARRIER_ACCOUNT_ID_ERROR,
    payload: {
      errorMessage,
    },
  };
}

// TODO: Add types to function params
export function getCarrierBuildingLocationTypes(carrierObj) {
  return <const>{
    type: ActionKeys.PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES,
    payload: {
      carrier: carrierObj.id,
    },
  };
}

export function getCarrierBuildingLocationTypesSuccess(payload: CarrierBuildingLocation[]) {
  return <const>{
    payload,
    type: ActionKeys.PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES_SUCCESS,
  };
}

// TODO: Add types to function params
export function getCarrierBuildingLocationTypesError(errorMessage: unknown) {
  return <const>{
    type: ActionKeys.PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES_ERROR,
    payload: {
      errorMessage,
    },
  };
}

// TODO: Add types to function params
export function sendPickupsRequest(
  carrierAccountId: string | undefined | null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  buildingLocationType: any,
  address: SavedAPIAddress,
  transactionObjectIds: string[],
  startTime: string,
  endTime: string,
  timeZone: string | undefined | null,
) {
  return <const>{
    type: ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST,
    payload: {
      carrierAccountId,
      buildingLocationType,
      address,
      transactionObjectIds,
      startTime,
      endTime,
      timeZone,
    },
  };
}

// TODO: Add types to function params
export function sendPickupsRequestSuccess(payload: {
  confirmationCode: string;
  pickupDate: string | null | undefined;
  pickupReadyByTime?: string | null | undefined;
  timeZone: string;
}) {
  return <const>{
    payload,
    type: ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST_SUCCESS,
  };
}

// TODO: Add types to function params
export function sendPickupsRequestError(errorMessage: unknown) {
  return <const>{
    type: ActionKeys.PICKUPS_SEND_PICKUPS_REQUEST_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export type PickupsActions =
  | ReturnType<typeof changePickupLocation>
  | ReturnType<typeof getTransactionsForCarrier>
  | ReturnType<typeof getTransactionsForCarrierSuccess>
  | ReturnType<typeof getTransactionsForCarrierError>
  | ReturnType<typeof getCarrierAccountId>
  | ReturnType<typeof getCarrierAccountIdSuccess>
  | ReturnType<typeof getCarrierAccountIdError>
  | ReturnType<typeof getCarrierBuildingLocationTypes>
  | ReturnType<typeof getCarrierBuildingLocationTypesSuccess>
  | ReturnType<typeof getCarrierBuildingLocationTypesError>
  | ReturnType<typeof sendPickupsRequest>
  | ReturnType<typeof sendPickupsRequestSuccess>
  | ReturnType<typeof sendPickupsRequestError>;
